var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContainerGender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F6E6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 22.9375L13.0627 27.0002",
    stroke: "#8C18C3",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 9H27V13.5",
    stroke: "#8C18C3",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0018 9L22.6758 13.326",
    stroke: "#8C18C3",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 26.9997L13.0905 22.9092",
    stroke: "#8C18C3",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.895 14.4414C17.8095 14.5067 17.721 14.5667 17.6445 14.6439C17.3198 14.9687 17.1022 15.3669 16.9822 15.7974C17.7997 15.9024 18.5587 16.2564 19.1512 16.8489C19.8592 17.5569 20.25 18.4989 20.25 19.5002C20.25 20.5014 19.8592 21.4434 19.1512 22.1522C18.4432 22.8609 17.5013 23.2502 16.5 23.2502C15.4987 23.2502 14.5568 22.8602 13.8488 22.1522C13.1408 21.4442 12.75 20.5014 12.75 19.5002C12.75 18.8514 12.9292 18.2357 13.2375 17.6844C13.1647 17.2974 13.125 16.9022 13.125 16.5002C13.125 16.1267 13.1625 15.7599 13.2248 15.3999C13.074 15.5214 12.927 15.6489 12.7882 15.7877C11.7967 16.7799 11.25 18.0977 11.25 19.5002C11.25 20.9027 11.7967 22.2204 12.7882 23.2127C13.7797 24.2049 15.0975 24.7502 16.5 24.7502C17.9025 24.7502 19.2202 24.2042 20.2117 23.2127C21.2032 22.2212 21.75 20.9027 21.75 19.5002C21.75 18.0977 21.2032 16.7799 20.2117 15.7877C19.5585 15.1344 18.762 14.6792 17.895 14.4414Z",
    fill: "#8C18C3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2117 12.7875C22.2202 11.796 20.9025 11.25 19.5 11.25C18.0975 11.25 16.7797 11.796 15.7882 12.7875C14.7967 13.779 14.25 15.0975 14.25 16.5C14.25 17.9025 14.7967 19.2202 15.7882 20.2125C16.4415 20.8657 17.238 21.321 18.105 21.5587C18.1905 21.4935 18.279 21.4335 18.3555 21.3562C18.6803 21.0315 18.8978 20.6332 19.0178 20.2027C18.2003 20.0977 17.4413 19.7437 16.8488 19.1512C16.1408 18.4432 15.75 17.5012 15.75 16.5C15.75 15.4987 16.1408 14.5567 16.8488 13.848C17.5568 13.1392 18.4987 12.75 19.5 12.75C20.5013 12.75 21.4432 13.14 22.1512 13.848C22.8592 14.556 23.25 15.4987 23.25 16.5C23.25 17.1487 23.0708 17.7645 22.7625 18.3157C22.8345 18.7027 22.875 19.098 22.875 19.5C22.875 19.8735 22.8375 20.2402 22.7753 20.6002C22.926 20.4787 23.073 20.3512 23.2117 20.2125C24.2032 19.2202 24.75 17.9025 24.75 16.5C24.75 15.0975 24.2032 13.7797 23.2117 12.7875Z",
    fill: "#8C18C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerGender);
export default __webpack_public_path__ + "static/media/Container-Gender.48cd4d256f14f596e3716f4f60991cc2.svg";
export { ForwardRef as ReactComponent };